import {DAMAGE_DICE_FACES} from '../../configs/damage';
import {MINUS_SIGN} from '../../constants/text';

const MAX_D6 = 6;

const formatFace = (face) => (face < 0 ? `${MINUS_SIGN}${Math.abs(face)}` : `${face}`);

/**
 * Подкрутка костей бота строками (пол броска d6, см. getBotD6MinRoll) — одна
 * на подсказку значка бота, подсказку выбора бонуса и раздел правил «Боты».
 * Сейчас кости подкручивает только уровень бонуса «божество», и пол у него 6:
 * каждый бросок d6 дает 6, кость урона — всегда свою лучшую грань. Пол ниже 6
 * ни у одного уровня сейчас нет, но строка для него готова: грани кости
 * монотонны по d6 (см. DAMAGE_DICE_FACES), поэтому пол — это худшая грань.
 * Пустой массив — кости честные.
 *
 * В бою с ботами подкрутка снимается (см. checkIfAnyOpponentIsBot): против
 * живых игроков и нейтральных отрядов кость урона божественного бота всегда
 * 0, против ботов — обычная, и строка «всегда 0» говорит об этом сама.
 *
 * @param {number} [d6MinRoll] - пол броска d6 бота (1 — честная кость)
 * @returns {string[]}
 */
export const getBotDiceBonusLines = (d6MinRoll) => {
  if (d6MinRoll >= MAX_D6) {
    return [`Кость урона всегда ${formatFace(DAMAGE_DICE_FACES[MAX_D6])}, кроме боя с другими ботами`];
  }
  if (d6MinRoll > 1) {
    return [`Кость урона не хуже ${formatFace(DAMAGE_DICE_FACES[d6MinRoll])}`];
  }
  return [];
};
